import { AppUrls } from "Custom/Globals";

/*
 * This file contains helper functions for building client routes, including handling company slug prefixing.
 */
const getCompanySlug = (): string | undefined => { return sessionStorage.getItem("companySlug") || undefined; };

const buildCompanyPrefix = (): string => {
    const companySlug = getCompanySlug();
    return companySlug ? `/${companySlug}` : "";
};

export const ClientRoutes = {
    root: () => `${buildCompanyPrefix()}/`,
    login: () => `${buildCompanyPrefix()}${AppUrls.Paths.login}`,
    logout: () => `${buildCompanyPrefix()}${AppUrls.Paths.logout}`,
    forgotPassword: () => `${buildCompanyPrefix()}${AppUrls.Paths.forgotPassword}`,
    ResetPassword: () => `${buildCompanyPrefix()}${AppUrls.Paths.resetPassword}`,
    CreatePassword: () => `${buildCompanyPrefix()}${AppUrls.Paths.createPassword}`,
    Dashboard: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Dashboard.replace(":propertyId", propertyId)}`,
    Choices: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Choices.replace(":propertyId", propertyId)}`,
    ChoicesArea: () => `${buildCompanyPrefix()}${AppUrls.Paths.ChoicesArea}`,
    ChoicesAreaProductGroup: () => `${buildCompanyPrefix()}${AppUrls.Paths.ChoicesAreaProductGroup}`,
    Documents: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Documents.replace(":propertyId", propertyId)}`,
    Inspection: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Inspection.replace(":propertyId", propertyId)}`,
    Property: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Property.replace(":propertyId", propertyId)}`,
    Progress: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Progress.replace(":propertyId", propertyId)}`,
    Snag: () => `${buildCompanyPrefix()}${AppUrls.Paths.Snag}`,
    Snags: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Snags.replace(":propertyId", propertyId)}`,
    Payment: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Payment.replace(":propertyId", propertyId)}`,
    Signatures: (propertyId: string) => `${buildCompanyPrefix()}${AppUrls.Paths.Signatures.replace(":propertyId", propertyId)}`,
    SignatureForm: () => `${buildCompanyPrefix()}${AppUrls.Paths.SignatureForm}`,
    SignatureRequest: () => `${buildCompanyPrefix()}${AppUrls.Paths.SignatureRequest}`,
    SuperAdmin: () => `${AppUrls.Paths.SuperAdmin}`,
};
